export const SessionQueries = {
    PROVIDER_AND_DATE: "Provider and date of service",
    PROVIDER_AND_DATE_RANGE: "Provider and date range",
    PROVIDER_AND_CLIENT: "Provider and client",
    DATE_OF_SERVICE: "Date of service",
    SUPERVISOR_AND_DATE_RANGE: "Supervisor and date range",
  };
  